module.exports = __webpack_public_path__ + "img/img3.0f9f827f.png";